<template>
  <div
    v-if="visible"
    :class="classes"
    @mouseenter="hoverLeft = true"
    @mouseleave="hoverLeft = false"
  >
    (
  </div>

  <slot></slot>

  <div
    v-if="visible"
    :class="classes"
    @mouseenter="hoverRight = true"
    @mouseleave="hoverRight = false"
  >
    )
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

const props = defineProps<{
  visible: boolean;
  baseClass?: string;
  hoverClass?: string;
}>();

const hoverLeft = ref(false);
const hoverRight = ref(false);
const hover = computed(() => hoverLeft.value || hoverRight.value);

const classes = computed(() =>
  hover.value
    ? props.hoverClass ?? "paren paren-hover"
    : props.baseClass ?? "paren"
);
</script>

<style scoped>
.paren {
  @apply kbd min-w-0;
  @apply transition-transform transition-colors;
}

.paren-hover {
  @apply scale-110 bg-accent/60;
}
</style>
